// Tiny helper to apply hospital branding to the document and convert hex -> rgb.
export function applyBranding(branding) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  const primary = (branding?.primary_color || "").trim();
  const accent = (branding?.accent_color || "").trim();
  if (primary) root.style.setProperty("--rxp-primary", primary);
  else root.style.removeProperty("--rxp-primary");
  if (accent) root.style.setProperty("--rxp-accent", accent);
  else root.style.removeProperty("--rxp-accent");
}

export function clearBranding() {
  if (typeof document === "undefined") return;
  document.documentElement.style.removeProperty("--rxp-primary");
  document.documentElement.style.removeProperty("--rxp-accent");
}
